export default function getScales(range, notes) {
    if (range < notes)
        return { scales: new Array(), error: "range must be greater than or equal to the number of notes" };
    if (range > 12 || notes > 12)
        return { scales: new Array(), error: "range and number of notes must be less than or equal to 12" };
    return { scales: calculateScales(range, notes, notes), error: "" };
}
// ref is need for recursive calls only and must be equal to k when manually calling calculateScales
function calculateScales(n, k, ref) {
    const scales = new Array();
    if (k === 1) {
        scales.push([n]);
        return scales;
    }
    for (let i = 1; i < n; i++) {
        for (let s of calculateScales(n - i, k - 1, ref)) {
            const scale = [i].concat(s);
            if (k !== ref || !duplicate(scale, scales)) {
                scales.push(scale);
            }
        }
    }
    return scales;
}
function duplicate(scale, scales) {
    for (let s of scales) {
        if (equivalent(scale, s)) {
            return true;
        }
    }
    return false;
}
function equivalent(scale1, scale2) {
    if (scale1.length !== scale2.length)
        return false;
    for (let r = 0; r < scale1.length; r++) {
        if (identical(scale1, rotate(scale2, r)))
            return true;
    }
    return false;
}
function rotate(scale, r) {
    const rotated = new Array();
    for (let i = 0; i < scale.length; i++) {
        rotated.push(scale[(r + i) % scale.length]);
    }
    return rotated;
}
function identical(scale1, scale2) {
    if (scale1.length !== scale2.length)
        return false;
    for (let i = 0; i < scale1.length; i++) {
        if (scale1[i] !== scale2[i])
            return false;
    }
    return true;
}
